import React, {useEffect, useState} from "react";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField} from "@mui/material";
import {Link} from "react-router-dom";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import axios from "axios";

const buttonSx = {
    height: "100%",
    width: "100%",
    textAlign: "center"
}

export default function SystemAdmin() {
    const [seedOpen, setSeedOpen] = useState(false)
    const [seedCount, setSeedCount] = useState(5)
    const [seedResult, setSeedResult] = useState<string | null>(null)
    const [seeding, setSeeding] = useState(false)
    const [testMode, setTestMode] = useState(false)

    useEffect(() => {
        axios.get('/admin/test-mode').then(({data}) => setTestMode(data.enabled)).catch(() => {})
    }, [])

    async function runSeed() {
        setSeeding(true)
        setSeedResult(null)
        await axios.post('/admin/seed-plots', {count: seedCount})
            .then(({data}) => setSeedResult(`Created ${data.created} test plot(s).`))
            .catch(() => setSeedResult('Error generating plots.'))
            .finally(() => setSeeding(false))
    }

    return <React.Fragment>
        <Grid container spacing={2} p={1}>
            <Grid item xs={12}>
                <Paper elevation={2} sx={{p: 1}}>
                    <Typography variant="h4" align="center">System Administration</Typography>
                </Paper>
            </Grid>
            <Grid item md={4} sm={6} xs={12}>
                <Button variant="contained" sx={buttonSx} component={Link} to="chapter">
                    <Typography>Chapter Manager</Typography>
                </Button>
            </Grid>
            <Grid item md={4} sm={6} xs={12}>
                <Button variant="contained" sx={buttonSx} component={Link} to="access_control">
                    <Typography>Access Control</Typography>
                </Button>
            </Grid>
            <Grid item md={4} sm={6} xs={12}>
                <Button variant="contained" sx={buttonSx} component={Link} to="events">
                    <Typography>Events</Typography>
                </Button>
            </Grid>
            <Grid item md={4} sm={6} xs={12}>
                <Button variant="contained" sx={buttonSx} component={Link} to="monster-abilities">
                    <Typography>Monster Ability Management</Typography>
                </Button>
            </Grid>
            <Grid item md={4} sm={6} xs={12}>
                <Button variant="contained" sx={buttonSx} component={Link} to="magic-item-admin">
                    <Typography>Magic Item Management</Typography>
                </Button>
            </Grid>
            <Grid item md={4} sm={6} xs={12}>
                <Button variant="contained" sx={buttonSx} component={Link} to="tp-items">
                    <Typography>TP Item Management</Typography>
                </Button>
            </Grid>
            <Grid item md={4} sm={6} xs={12}>
                <Button variant="contained" sx={buttonSx} component={Link} to="event-sites">
                    <Typography>Event Site Management</Typography>
                </Button>
            </Grid>
            {testMode && (
                <Grid item md={4} sm={6} xs={12}>
                    <Button variant="contained" color="warning" sx={buttonSx} onClick={() => { setSeedResult(null); setSeedOpen(true) }}>
                        <Typography>Seed Test Plots</Typography>
                    </Button>
                </Grid>
            )}
        </Grid>

        <Dialog open={seedOpen} onClose={() => setSeedOpen(false)}>
            <DialogTitle>Seed Test Plots</DialogTitle>
            <DialogContent sx={{pt: 2, display: 'flex', flexDirection: 'column', gap: 2}}>
                <Typography variant="body2" color="text.secondary">
                    Generates randomized test plots with hooks, monsters, and event assignments.
                    Plots are marked with a [Test] prefix. Status and event assignment are random.
                </Typography>
                <TextField
                    label="Number of plots"
                    type="number"
                    value={seedCount}
                    inputProps={{min: 1, max: 50}}
                    onChange={ev => setSeedCount(Math.min(50, Math.max(1, parseInt(ev.target.value) || 1)))}
                />
                {seedResult && (
                    <Typography variant="body2" color={seedResult.startsWith('Error') ? 'error' : 'success.main'}>
                        {seedResult}
                    </Typography>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setSeedOpen(false)}>Close</Button>
                <Button variant="contained" color="warning" disabled={seeding} onClick={runSeed}>
                    {seeding ? 'Generating…' : 'Generate'}
                </Button>
            </DialogActions>
        </Dialog>
    </React.Fragment>
}
